import React from 'react';
import { View, useIsMobile } from 'hooks';
import DesktopPageLayout from './desktopLayout/DesktopPageLayout';
import TabletPageLayout from './tabletLayout/TabletPageLayout';
import MobilePageLayout from './mobileLayout/MobilePageLayout';

export interface PageLayoutProps {
  children: React.ReactNode;
}

function PageLayout({ children }: PageLayoutProps) {
  const { view } = useIsMobile();
  const content = () => {
    if (view === View.Mobile) {
      return <MobilePageLayout>{children}</MobilePageLayout>;
    }
    if (view === View.Tablet) {
      return <TabletPageLayout>{children}</TabletPageLayout>;
    }
    return <DesktopPageLayout>{children}</DesktopPageLayout>;
  };
  return content();
}

export default PageLayout;
